import {
  createElement,
  type AnchorHTMLAttributes,
  type ComponentType,
  type ImgHTMLAttributes,
} from "react";

export type AbyssImagePrimitiveProps = ImgHTMLAttributes<HTMLImageElement> & {
  alt: string;
  imageClassName?: string;
  priority?: boolean;
  src: string;
};

export type AbyssLinkPrimitiveProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  href: string;
};

export type AbyssPrimitiveRegistry = {
  Image: ComponentType<AbyssImagePrimitiveProps>;
  Link: ComponentType<AbyssLinkPrimitiveProps>;
};

export type AbyssPrimitiveName = keyof AbyssPrimitiveRegistry;

const Image = ({ imageClassName, priority: _priority, ...props }: AbyssImagePrimitiveProps) =>
  createElement("img", {
    ...props,
    className: [props.className, imageClassName].filter(Boolean).join(" ") || undefined,
  });

const Link = ({ children, rel, target, ...props }: AbyssLinkPrimitiveProps) =>
  createElement(
    "a",
    { ...props, rel: target === "_blank" && !rel ? "noopener noreferrer" : rel, target },
    children,
  );

const registry: AbyssPrimitiveRegistry = { Image, Link };

export function registerComponent<K extends AbyssPrimitiveName>(
  name: K,
  component: AbyssPrimitiveRegistry[K],
) {
  registry[name] = component;
}

export function getComponent<K extends AbyssPrimitiveName>(name: K): AbyssPrimitiveRegistry[K] {
  return registry[name];
}
